var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container__wrap"},[_c('div',{staticClass:"main-container"},[_c('app-menu',{attrs:{"game":_vm.game}}),_c('div',{staticClass:"main-container__content"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }